import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfServicePage: React.FC = () => {
  const lastUpdated = "January 1, 2024";
  const companyName = "SaaS Starter Inc.";
  
  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 max-w-3xl">
      <header className="mb-10 text-center">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-foreground mb-3">Terms of Service</h1>
        <p className="text-sm text-muted-foreground">Last Updated: {lastUpdated}</p>
      </header>

      <section className="space-y-6 text-foreground/90 leading-relaxed">
        <p>
          Welcome to {companyName}. These Terms of Service govern your access to and use of our website and services.
        </p>
        <p>
            This is a generic terms of service template. Replace with your legal text.
        </p>
        <h2 className="text-2xl font-semibold pt-4 border-b pb-2">1. Acceptance of Terms</h2>
        <p>
            By accessing our services, you agree to be bound by these Terms.
        </p>
      </section>
    </div>
  );
};

export default TermsOfServicePage;
